/**
 * @license
 * Copyright Workylab. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/workylab/materialize-angular/master/LICENSE
 */

import { DayLabels } from '../completed-components/calendar/calendar.model';

export const days: DayLabels = {
  friday: {
    name: 'Friday',
    shortName: 'Fri',
    shortestName: 'Fr'
  },
  monday: {
    name: 'Monday',
    shortName: 'Mon',
    shortestName: 'Mo'
  },
  saturday: {
    name: 'Saturday',
    shortName: 'Sat',
    shortestName: 'Sa'
  },
  sunday: {
    name: 'Sunday',
    shortName: 'Sun',
    shortestName: 'Su'
  },
  thursday: {
    name: 'Thursday',
    shortName: 'Thu',
    shortestName: 'Th'
  },
  tuesday: {
    name: 'Tuesday',
    shortName: 'Tue',
    shortestName: 'Tu'
  },
  wednesday: {
    name: 'Wednesday',
    shortName: 'Wed',
    shortestName: 'We'
  }
};
